// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Minimal Mobile Dashboard Styles - Using Bootstrap Where Possible */

/* ================================
  Mobile Dashboard Container
  ================================ */
.mobile-dashboard {
  left: 0;
  top: 0;
  width: 100%;
}
.mobile-fixed-header {
  z-index: 101;
}

.mobile-scroll-touch {
  -webkit-overflow-scrolling: touch;
}

/* Header with gradient */
.mobile-header-gradient {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
  z-index: 100;
}

.mobile-header-gradient .type-selector {
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);
}

/* Order Type Selector Buttons */
.mobile-order-type-active {
  background: #ff6b6b !important;
  color: white !important;
  border: 2px solid #ff6b6b !important;
  min-width: 85px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.mobile-order-type-active:hover {
  background: #ff5555 !important;
  border-color: #ff5555 !important;
  transform: translateY(-2px);
}

.mobile-order-type-active i {
  font-size: 14px;
}

.mobile-order-type-inactive {
  background: white;
  color: #2c3e50;
  border: 2px solid #ecf0f1;
  min-width: 85px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 20px;
  white-space: nowrap;
  transition: all 0.3s ease;
}

.mobile-order-type-inactive:hover {
  border-color: #ff6b6b;
  color: #ff6b6b;
  transform: translateY(-2px);
}

.mobile-order-type-inactive i {
  font-size: 14px;
}

/* Active Order Banner */
.mobile-active-banner {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
}

/* ================================
  Categories
  ================================ */
.mobile-categories-scroll {
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.mobile-categories-scroll::-webkit-scrollbar {
  display: none;
}

.mobile-category-img {
  object-fit: cover;
}

.mobile-category-icon-font {
  font-size: 28px;
}

.mobile-category-icon {
  width: 60px;
  height: 60px;
  transition: all 0.3s ease;
}

.mobile-category-active {
  background: #2c3e50 !important;
  color: white !important;
  transform: scale(1.05);
}

.mobile-category-inactive {
  background: #f8f9fa;
  color: #7f8c8d;
}

.mobile-category-name {
  font-size: 12px;
  line-height: 1.2;
  word-wrap: break-word;
  overflow-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 80px;
}

/* Bottom Navigation */
.mobile-bottom-nav {
  background: #2c3e50;
  border-radius: 100rem;
  z-index: 100;
  column-gap: 2rem;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0.5rem;
  padding: 8px 0px 15px 0px;
}

.mobile-bottom-nav .btn:hover,
.btn:focus,
.btn.focus {
  box-shadow: none !important;
}
.mobile-nav-active {
  color: white !important;
  transition: all 0.3s ease;
}

.mobile-nav-active i {
  font-size: 18px;
}

.mobile-nav-inactive {
  color: #bebebe !important;
  transition: all 0.3s ease;
}

.mobile-nav-inactive i {
  font-size: 20px;
}

.mobile-nav-dot {
  width: 6px;
  height: 6px;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
}

.mobile-nav-badge {
  background: #e74c3c !important;
  color: white !important;
  font-size: 10px;
  min-width: 18px;
  font-weight: bold;
  top: 5px !important;
  right: 15px !important;
}

/* Hide scrollbar for horizontal scrolling */
.overflow-auto::-webkit-scrollbar {
  display: none;
}

.overflow-auto {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.all-items-list {
  padding-bottom: 75px;
}

/* ================================
  Items List
  ================================ */
.mobile-no-items-icon {
  font-size: 48px;
  color: #bdc3c7;
}

.mobile-item-card {
  border-radius: 10px;
}

.mobile-item-img-container {
  height: 90px;
  overflow: hidden;
}

.mobile-item-img {
  object-fit: cover;
  border-radius: 8px;
}

.mobile-item-rating {
  font-size: 12px;
  font-weight: 600;
}

/* ================================
  Cart Drawer
  ================================ */
/* Header styling is now in the flex layout section above */

.mobile-cart-close-btn {
  font-size: 24px;
}

.mobile-cart-empty-icon {
  font-size: 64px;
  opacity: 0.3;
}

/* KOT Badge - Matches Desktop Purple Theme */
.mobile-cart-kot-badge {
  background: #9ba7ca;
  font-size: 13px;
}

/* Match desktop bg-purple color for KOT headers */
.bg-purple {
  background-color: #9ba7ca !important;
}

.mobile-cart-delete-btn {
  color: #e74c3c;
  font-size: 18px;
}

.mobile-cart-qty-btn {
  width: 24px;
  height: 24px;
  background: #ff6b6b;
  color: white;
  font-size: 16px;
}

.mobile-cart-qty-text {
  min-width: 20px;
  text-align: center;
}

.mobile-cart-clear-btn {
  color: #e74c3c;
  font-size: 14px;
}

.mobile-cart-total-label {
  font-size: 14px;
}

.mobile-cart-total-amount {
  font-size: 24px;
  color: #2c3e50;
}

.mobile-cart-checkout-btn {
  background: #ff6b6b;
  border-radius: 30px;
  font-size: 16px;
  border: none;
}

/* Removed old button grid and input styles - Now using desktop ActionButtons component */

/* Cart Drawer Animation - Matches Desktop Structure */
.mobile-cart-drawer {
  position: fixed;
  top: 0;
  right: -100%;
  width: 100%;
  max-width: 400px;
  height: 100vh;
  background: white;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);
  transition: right 0.3s ease;
  z-index: 1030;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.mobile-cart-drawer.open {
  right: 0;
}

/* Fixed Header */
.mobile-cart-drawer .mobile-cart-header {
  flex-shrink: 0;
  background: white;
  border-bottom: 1px solid #e9ecef;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

/* Scrollable Content Area - Clean White Background Like Desktop */
.mobile-cart-drawer .mobile-cart-content {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  background: white;
  min-height: 0;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

/* Mobile-specific adjustments for components in cart content */
.mobile-cart-drawer .mobile-cart-content .border-top {
  background: white;
  margin: 0;
}

/* Accordion header styling in mobile */
.mobile-cart-drawer .mobile-cart-content .border-top > div:first-child {
  background-color: #f8f9fa;
  border-radius: 0;
}

/* Ensure proper spacing for all child components */
.mobile-cart-drawer .mobile-cart-content > div {
  background: white;
}

/* Mobile adjustments for OrderItemsList component */
.mobile-cart-drawer .mobile-cart-content .mt-2 {
  margin-top: 0.5rem !important;
}

.mobile-cart-drawer .mobile-cart-content .bg-purple {
  background-color: #9ba7ca !important;
  font-size: 12px;
  padding: 6px 12px !important;
}

/* Mobile item cards in cart */
.mobile-cart-drawer .mobile-cart-content .btn-outline-dark,
.mobile-cart-drawer .mobile-cart-content .btn-outline-danger {
  border-width: 1px;
}

.mobile-cart-drawer .mobile-cart-content .btn-sm {
  font-size: 14px;
}

/* Touch-friendly spacing */
.mobile-cart-drawer .mobile-cart-content .gap-1 {
  gap: 0.25rem !important;
}

/* Accordion in Mobile Footer - Styling */
.mobile-cart-drawer .mobile-cart-footer .border-top {
  background: white;
  border-color: #e9ecef;
}

.mobile-cart-drawer .mobile-cart-footer .cursor-pointer {
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* Accordion collapse animation - Only accordion content scrolls if needed */
.mobile-cart-drawer .mobile-cart-footer .collapse {
  transition: height 0.3s ease;
  overflow: visible;
}

/* Accordion content styling */
.mobile-cart-drawer .mobile-cart-footer .border-top .form-control-sm {
  font-size: 13px;
  padding: 0.5rem;
}

.mobile-cart-drawer .mobile-cart-footer .border-top .small {
  font-size: 12px;
}

/* Order Summary in mobile footer - adjust padding */
.mobile-cart-drawer .mobile-cart-footer .p-3:not(.action-buttons .p-3) {
  padding: 0.75rem !important;
}

.mobile-cart-drawer .mobile-cart-footer .mb-1,
.mobile-cart-drawer .mobile-cart-footer .small {
  font-size: 12px;
}

/* Mobile Grand Total in footer - matches desktop */
.mobile-cart-total-amount {
  font-size: 20px;
  color: #006400;
}

/* Action Buttons in Mobile - Compact Like Desktop */
.mobile-cart-drawer .action-buttons {
  padding: 0.75rem !important;
  padding-top: 0 !important;
}

.mobile-cart-drawer .action-buttons .row {
  flex: 1;
  gap: 4px;
  margin: 0;
}

.mobile-cart-drawer .action-buttons .col {
  padding: 0 2px;
}

.mobile-cart-drawer .action-buttons .btn {
  font-size: 10px;
  padding: 6px 4px;
  white-space: nowrap;
  border-radius: 4px;
  font-weight: 600;
  min-height: 32px;
}

.mobile-cart-drawer .action-buttons .btn i {
  font-size: 12px;
  margin-right: 2px;
}

.mobile-cart-drawer .action-buttons .settle {
  min-width: 75px;
  margin-left: 6px;
}

.mobile-cart-drawer .action-buttons .settle .btn {
  border-radius: 6px;
  padding: 6px 8px;
  min-height: 68px;
}

.mobile-cart-drawer .action-buttons .settle .title {
  font-size: 11px;
  margin-bottom: 2px;
}

.mobile-cart-drawer .action-buttons .settle .total {
  font-size: 15px;
  line-height: 13px;
  margin-top: 2px;
}

/* Ensure action buttons are touch-friendly */
.mobile-cart-drawer .action-buttons .btn:active {
  transform: scale(0.96);
  transition: transform 0.1s ease;
}

/* Fixed Footer Container - Matches Desktop, Accordion Opens Upward */
.mobile-cart-drawer .mobile-cart-footer {
  padding: 0;
  flex-shrink: 0;
  background: white;
  border-top: 2px solid #e9ecef;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  overflow: visible; /* Allow accordion to expand upward */
}

/* Stack order in footer - Accordion first (top), then summary, then buttons */
.mobile-cart-drawer .mobile-cart-footer > div:nth-child(1) {
  flex-shrink: 0;
}

.mobile-cart-drawer .mobile-cart-footer > div:nth-child(2) {
  flex-shrink: 0;
}

.mobile-cart-drawer .mobile-cart-footer > div:nth-child(3) {
  flex-shrink: 0;
}

.mobile-cart-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1020;
  opacity: 0;
  visibility: hidden;
  transition: all 0.3s ease;
}

.mobile-cart-overlay.open {
  opacity: 1;
  visibility: visible;
}

/* Touch feedback */
.cursor-pointer {
  cursor: pointer;
}

/* Variants Modal Animation */
.mobile-variants-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: flex-end;
  z-index: 1060;
}

.mobile-variants-content {
  background: white;
  width: 100%;
  border-radius: 20px 20px 0 0;
  max-height: 70vh;
  overflow-y: auto;
  animation: slideUp 0.3s ease;
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

/* Responsive - Hide mobile view on desktop */
@media (min-width: 769px) {
  .d-flex.flex-column.vh-100.bg-light {
    display: none !important;
  }
}

/* Custom styles for items that Bootstrap doesn't cover */
.mobile-item-card {
  transition: transform 0.2s;
}

.mobile-item-card:active {
  transform: scale(0.98);
}

/* Table View Styles */
.mobile-table-view-container {
  padding: 0.5rem 1rem;
  padding-bottom: 75px;
  overflow-x: hidden;
  position: relative;
}

/* Order Filter Tabs - For All Orders View */
.mobile-order-filter-tabs {
  display: inline-flex;
  width: 100%;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  overflow: hidden;
  background: white;
  -webkit-overflow-scrolling: touch;
}

.mobile-order-filter-tabs::-webkit-scrollbar {
  display: none;
}

.mobile-order-filter-tab {
  flex: 1;
  min-width: 90px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-right: 1px solid #e9ecef;
  background: white;
  border-radius: 0;
  font-size: 13px;
  font-weight: 600;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.2s ease;
}

.mobile-order-filter-tab:last-child {
  border-right: none;
}
.mobile-order-filter-tab.active {
  background: #2c3e50;
  border-color: #2c3e50;
  color: white;
  position: relative;
  z-index: 1;
}

.mobile-order-filter-tab i {
  font-size: 18px;
}

.mobile-order-filter-tab span {
  font-size: 12px;
  white-space: nowrap;
  font-weight: 600;
}

.mobile-table-types-container {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  overflow-x: scroll;
  width: auto;
}

.mobile-table-types-container::-webkit-scrollbar {
  display: none;
}

.mobile-table-types-container::-webkit-scrollbar-track {
  background: #f8f9fa;
}

.mobile-table-types-container::-webkit-scrollbar-thumb {
  background: #e9ecef;
}

.mobile-table-types-container::-webkit-scrollbar-thumb:hover {
  background: #dee2e6;
}

.mobile-table-type-filter-btn span {
  font-size: 14px;
  font-weight: 600;
}

.mobile-table-type-filter-btn {
  white-space: nowrap;
  border-radius: 5px;
  flex: 1;
}

.mobile-table-type-filter-btn i {
  font-size: 20px;
  margin-right: 0.5rem;
}

.mobile-table-layout-container {
  position: relative;
}

.mobile-tables-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  max-width: 450px;
  margin: 0 auto;
}

.mobile-table-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
}

.mobile-table-wrapper {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.3s;
  padding: 15px;
}

.mobile-table-number-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 14px;
  position: relative;
  z-index: 2;
  transition: all 0.3s;
}

.mobile-table-number-circle.active {
  background: #ff6b6b;
  color: white;
  transform: scale(1.1);
}

.mobile-table-number-circle.reserved {
  background: #2c3e50;
  color: white;
}

.mobile-table-number-circle.available {
  background: #ecf0f1;
  color: #2c3e50;
}

/* Order Cards */
.mobile-order-card {
  border-radius: 0.75rem;
  padding: 1rem;
  margin-bottom: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.mobile-order-card.active {
  background: #2c3e50;
  border: 2px solid #ff6b6b;
}

/* Delete Button Inline on Mobile Order Cards */
.mobile-order-delete-btn-inline {
  background: transparent;
  border: none;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.mobile-order-delete-btn-inline:hover {
  transform: scale(1.2);
}

.mobile-order-delete-btn-inline:active {
  transform: scale(0.9);
}

.mobile-order-delete-btn-inline .mdi-close-circle {
  font-size: 24px;
  color: #dc3545;
}

/* For active cards, make delete icon white/visible */
.mobile-order-card.active .mobile-order-delete-btn-inline .mdi-close-circle {
  color: #ff6b6b;
}

.mobile-order-card.dine-in {
  background: #ffeaad;
}

.mobile-order-card.parcel {
  background: #e3c8fa;
}

.mobile-order-card.delivery {
  background: #c6ffba;
}

.mobile-order-card.inactive {
  background: #f8f9fa;
}

.mobile-order-card-text {
  color: #2c3e50;
}

.mobile-order-card.active .mobile-order-card-text {
  color: white;
}

.mobile-order-card-subtitle {
  color: #7f8c8d;
}

.mobile-order-card.active .mobile-order-card-subtitle {
  color: rgba(255, 255, 255, 0.8);
}

.mobile-order-card-address {
  color: #95a5a6;
}

.mobile-order-card.active .mobile-order-card-address {
  color: rgba(255, 255, 255, 0.6);
}

.mobile-order-card-price {
  color: #ff6b6b;
}

.mobile-order-card.active .mobile-order-card-price {
  color: white;
}

.mobile-order-badge-active {
  background: #ff6b6b;
  font-size: 11px;
}

.mobile-order-badge-parcel {
  background: #27ae60;
  font-size: 11px;
}

.mobile-order-badge-delivery {
  background: #e67e22;
  font-size: 11px;
}

/* Empty State */
.mobile-empty-state {
  text-align: center;
  padding: 3rem 0;
  color: #7f8c8d;
}

.mobile-empty-state i {
  font-size: 48px;
  opacity: 0.3;
}

/* Legend */
.mobile-table-legend {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #dee2e6;
}

.mobile-legend-box {
  width: 20px;
  height: 20px;
  border-radius: 0.25rem;
}

/* Table chair decorations */
.mobile-table-chairs {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90px;
  height: 90px;
  pointer-events: none;
}

.mobile-chair {
  position: absolute;
  width: 18px;
  height: 24px;
  /* background: #bdc3c7;
 border-radius: 6px 6px 3px 3px; */
}

.mobile-chair.top {
  top: 10px;
  left: 50%;
  transform: translateX(-50%) rotate(-10deg);
}

.mobile-chair.right {
  right: 10px;
  top: 50%;
  transform: translateY(-50%) rotate(80deg);
}

.mobile-chair.bottom {
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%) rotate(170deg);
}

.mobile-chair.left {
  left: 10px;
  top: 50%;
  transform: translateY(-50%) rotate(260deg);
}
`, "",{"version":3,"sources":["webpack://./src/pages/OrderDashboard/MobileView/MobileOrderDashboard.css"],"names":[],"mappings":"AAAA,qEAAqE;;AAErE;;oCAEoC;AACpC;EACE,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA,yBAAyB;AACzB;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA,gCAAgC;AAChC;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,6DAA6D;EAC7D,kBAAkB;AACpB;;AAEA;;oCAEoC;AACpC;EACE,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,2BAA2B;AAC7B;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;oCAEoC;AACpC;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;;oCAEoC;AACpC,2DAA2D;;AAE3D;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,kDAAkD;AAClD;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA,yFAAyF;;AAEzF,sDAAsD;AACtD;EACE,eAAe;EACf,MAAM;EACN,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,QAAQ;AACV;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,kEAAkE;AAClE;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iCAAiC,EAAE,4BAA4B;AACjE;;AAEA,+DAA+D;AAC/D;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;AACnB;;AAEA,oDAAoD;AACpD;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,4BAA4B;AAC9B;;AAEA,8BAA8B;AAC9B;;EAEE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA,2BAA2B;AAC3B;EACE,uBAAuB;AACzB;;AAEA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAEA,4EAA4E;AAC5E;EACE,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,eAAe;AACjB;;AAEA,mDAAmD;AACnD;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA,qEAAqE;AACrE;EACE,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,iBAAiB,EAAE,qCAAqC;AAC1D;;AAEA,8EAA8E;AAC9E;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,eAAe;AACjB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA,yDAAyD;AACzD;EACE,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,OAAO;EACP,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,+CAA+C;AAC/C;EACE,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,WAAW;AACX;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ;kCACgC;AAClC;;AAEA;EACE,SAAS;EACT,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,0CAA0C;AAC5C","sourcesContent":["/* Minimal Mobile Dashboard Styles - Using Bootstrap Where Possible */\n\n/* ================================\n  Mobile Dashboard Container\n  ================================ */\n.mobile-dashboard {\n  left: 0;\n  top: 0;\n  width: 100%;\n}\n.mobile-fixed-header {\n  z-index: 101;\n}\n\n.mobile-scroll-touch {\n  -webkit-overflow-scrolling: touch;\n}\n\n/* Header with gradient */\n.mobile-header-gradient {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n  z-index: 100;\n}\n\n.mobile-header-gradient .type-selector {\n  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%);\n}\n\n/* Order Type Selector Buttons */\n.mobile-order-type-active {\n  background: #ff6b6b !important;\n  color: white !important;\n  border: 2px solid #ff6b6b !important;\n  min-width: 85px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 20px;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.mobile-order-type-active:hover {\n  background: #ff5555 !important;\n  border-color: #ff5555 !important;\n  transform: translateY(-2px);\n}\n\n.mobile-order-type-active i {\n  font-size: 14px;\n}\n\n.mobile-order-type-inactive {\n  background: white;\n  color: #2c3e50;\n  border: 2px solid #ecf0f1;\n  min-width: 85px;\n  font-size: 11px;\n  font-weight: 600;\n  border-radius: 20px;\n  white-space: nowrap;\n  transition: all 0.3s ease;\n}\n\n.mobile-order-type-inactive:hover {\n  border-color: #ff6b6b;\n  color: #ff6b6b;\n  transform: translateY(-2px);\n}\n\n.mobile-order-type-inactive i {\n  font-size: 14px;\n}\n\n/* Active Order Banner */\n.mobile-active-banner {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  position: relative;\n}\n\n/* ================================\n  Categories\n  ================================ */\n.mobile-categories-scroll {\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n}\n\n.mobile-categories-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-category-img {\n  object-fit: cover;\n}\n\n.mobile-category-icon-font {\n  font-size: 28px;\n}\n\n.mobile-category-icon {\n  width: 60px;\n  height: 60px;\n  transition: all 0.3s ease;\n}\n\n.mobile-category-active {\n  background: #2c3e50 !important;\n  color: white !important;\n  transform: scale(1.05);\n}\n\n.mobile-category-inactive {\n  background: #f8f9fa;\n  color: #7f8c8d;\n}\n\n.mobile-category-name {\n  font-size: 12px;\n  line-height: 1.2;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 80px;\n}\n\n/* Bottom Navigation */\n.mobile-bottom-nav {\n  background: #2c3e50;\n  border-radius: 100rem;\n  z-index: 100;\n  column-gap: 2rem;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 0.5rem;\n  padding: 8px 0px 15px 0px;\n}\n\n.mobile-bottom-nav .btn:hover,\n.btn:focus,\n.btn.focus {\n  box-shadow: none !important;\n}\n.mobile-nav-active {\n  color: white !important;\n  transition: all 0.3s ease;\n}\n\n.mobile-nav-active i {\n  font-size: 18px;\n}\n\n.mobile-nav-inactive {\n  color: #bebebe !important;\n  transition: all 0.3s ease;\n}\n\n.mobile-nav-inactive i {\n  font-size: 20px;\n}\n\n.mobile-nav-dot {\n  width: 6px;\n  height: 6px;\n  bottom: -6px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.mobile-nav-badge {\n  background: #e74c3c !important;\n  color: white !important;\n  font-size: 10px;\n  min-width: 18px;\n  font-weight: bold;\n  top: 5px !important;\n  right: 15px !important;\n}\n\n/* Hide scrollbar for horizontal scrolling */\n.overflow-auto::-webkit-scrollbar {\n  display: none;\n}\n\n.overflow-auto {\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.all-items-list {\n  padding-bottom: 75px;\n}\n\n/* ================================\n  Items List\n  ================================ */\n.mobile-no-items-icon {\n  font-size: 48px;\n  color: #bdc3c7;\n}\n\n.mobile-item-card {\n  border-radius: 10px;\n}\n\n.mobile-item-img-container {\n  height: 90px;\n  overflow: hidden;\n}\n\n.mobile-item-img {\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.mobile-item-rating {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n/* ================================\n  Cart Drawer\n  ================================ */\n/* Header styling is now in the flex layout section above */\n\n.mobile-cart-close-btn {\n  font-size: 24px;\n}\n\n.mobile-cart-empty-icon {\n  font-size: 64px;\n  opacity: 0.3;\n}\n\n/* KOT Badge - Matches Desktop Purple Theme */\n.mobile-cart-kot-badge {\n  background: #9ba7ca;\n  font-size: 13px;\n}\n\n/* Match desktop bg-purple color for KOT headers */\n.bg-purple {\n  background-color: #9ba7ca !important;\n}\n\n.mobile-cart-delete-btn {\n  color: #e74c3c;\n  font-size: 18px;\n}\n\n.mobile-cart-qty-btn {\n  width: 24px;\n  height: 24px;\n  background: #ff6b6b;\n  color: white;\n  font-size: 16px;\n}\n\n.mobile-cart-qty-text {\n  min-width: 20px;\n  text-align: center;\n}\n\n.mobile-cart-clear-btn {\n  color: #e74c3c;\n  font-size: 14px;\n}\n\n.mobile-cart-total-label {\n  font-size: 14px;\n}\n\n.mobile-cart-total-amount {\n  font-size: 24px;\n  color: #2c3e50;\n}\n\n.mobile-cart-checkout-btn {\n  background: #ff6b6b;\n  border-radius: 30px;\n  font-size: 16px;\n  border: none;\n}\n\n/* Removed old button grid and input styles - Now using desktop ActionButtons component */\n\n/* Cart Drawer Animation - Matches Desktop Structure */\n.mobile-cart-drawer {\n  position: fixed;\n  top: 0;\n  right: -100%;\n  width: 100%;\n  max-width: 400px;\n  height: 100vh;\n  background: white;\n  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.2);\n  transition: right 0.3s ease;\n  z-index: 1030;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.mobile-cart-drawer.open {\n  right: 0;\n}\n\n/* Fixed Header */\n.mobile-cart-drawer .mobile-cart-header {\n  flex-shrink: 0;\n  background: white;\n  border-bottom: 1px solid #e9ecef;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n/* Scrollable Content Area - Clean White Background Like Desktop */\n.mobile-cart-drawer .mobile-cart-content {\n  flex: 1;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: white;\n  min-height: 0;\n  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n}\n\n/* Mobile-specific adjustments for components in cart content */\n.mobile-cart-drawer .mobile-cart-content .border-top {\n  background: white;\n  margin: 0;\n}\n\n/* Accordion header styling in mobile */\n.mobile-cart-drawer .mobile-cart-content .border-top > div:first-child {\n  background-color: #f8f9fa;\n  border-radius: 0;\n}\n\n/* Ensure proper spacing for all child components */\n.mobile-cart-drawer .mobile-cart-content > div {\n  background: white;\n}\n\n/* Mobile adjustments for OrderItemsList component */\n.mobile-cart-drawer .mobile-cart-content .mt-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mobile-cart-drawer .mobile-cart-content .bg-purple {\n  background-color: #9ba7ca !important;\n  font-size: 12px;\n  padding: 6px 12px !important;\n}\n\n/* Mobile item cards in cart */\n.mobile-cart-drawer .mobile-cart-content .btn-outline-dark,\n.mobile-cart-drawer .mobile-cart-content .btn-outline-danger {\n  border-width: 1px;\n}\n\n.mobile-cart-drawer .mobile-cart-content .btn-sm {\n  font-size: 14px;\n}\n\n/* Touch-friendly spacing */\n.mobile-cart-drawer .mobile-cart-content .gap-1 {\n  gap: 0.25rem !important;\n}\n\n/* Accordion in Mobile Footer - Styling */\n.mobile-cart-drawer .mobile-cart-footer .border-top {\n  background: white;\n  border-color: #e9ecef;\n}\n\n.mobile-cart-drawer .mobile-cart-footer .cursor-pointer {\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n/* Accordion collapse animation - Only accordion content scrolls if needed */\n.mobile-cart-drawer .mobile-cart-footer .collapse {\n  transition: height 0.3s ease;\n  overflow: visible;\n}\n\n/* Accordion content styling */\n.mobile-cart-drawer .mobile-cart-footer .border-top .form-control-sm {\n  font-size: 13px;\n  padding: 0.5rem;\n}\n\n.mobile-cart-drawer .mobile-cart-footer .border-top .small {\n  font-size: 12px;\n}\n\n/* Order Summary in mobile footer - adjust padding */\n.mobile-cart-drawer .mobile-cart-footer .p-3:not(.action-buttons .p-3) {\n  padding: 0.75rem !important;\n}\n\n.mobile-cart-drawer .mobile-cart-footer .mb-1,\n.mobile-cart-drawer .mobile-cart-footer .small {\n  font-size: 12px;\n}\n\n/* Mobile Grand Total in footer - matches desktop */\n.mobile-cart-total-amount {\n  font-size: 20px;\n  color: #006400;\n}\n\n/* Action Buttons in Mobile - Compact Like Desktop */\n.mobile-cart-drawer .action-buttons {\n  padding: 0.75rem !important;\n  padding-top: 0 !important;\n}\n\n.mobile-cart-drawer .action-buttons .row {\n  flex: 1;\n  gap: 4px;\n  margin: 0;\n}\n\n.mobile-cart-drawer .action-buttons .col {\n  padding: 0 2px;\n}\n\n.mobile-cart-drawer .action-buttons .btn {\n  font-size: 10px;\n  padding: 6px 4px;\n  white-space: nowrap;\n  border-radius: 4px;\n  font-weight: 600;\n  min-height: 32px;\n}\n\n.mobile-cart-drawer .action-buttons .btn i {\n  font-size: 12px;\n  margin-right: 2px;\n}\n\n.mobile-cart-drawer .action-buttons .settle {\n  min-width: 75px;\n  margin-left: 6px;\n}\n\n.mobile-cart-drawer .action-buttons .settle .btn {\n  border-radius: 6px;\n  padding: 6px 8px;\n  min-height: 68px;\n}\n\n.mobile-cart-drawer .action-buttons .settle .title {\n  font-size: 11px;\n  margin-bottom: 2px;\n}\n\n.mobile-cart-drawer .action-buttons .settle .total {\n  font-size: 15px;\n  line-height: 13px;\n  margin-top: 2px;\n}\n\n/* Ensure action buttons are touch-friendly */\n.mobile-cart-drawer .action-buttons .btn:active {\n  transform: scale(0.96);\n  transition: transform 0.1s ease;\n}\n\n/* Fixed Footer Container - Matches Desktop, Accordion Opens Upward */\n.mobile-cart-drawer .mobile-cart-footer {\n  padding: 0;\n  flex-shrink: 0;\n  background: white;\n  border-top: 2px solid #e9ecef;\n  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);\n  display: flex;\n  flex-direction: column;\n  overflow: visible; /* Allow accordion to expand upward */\n}\n\n/* Stack order in footer - Accordion first (top), then summary, then buttons */\n.mobile-cart-drawer .mobile-cart-footer > div:nth-child(1) {\n  flex-shrink: 0;\n}\n\n.mobile-cart-drawer .mobile-cart-footer > div:nth-child(2) {\n  flex-shrink: 0;\n}\n\n.mobile-cart-drawer .mobile-cart-footer > div:nth-child(3) {\n  flex-shrink: 0;\n}\n\n.mobile-cart-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 1020;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.3s ease;\n}\n\n.mobile-cart-overlay.open {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Touch feedback */\n.cursor-pointer {\n  cursor: pointer;\n}\n\n/* Variants Modal Animation */\n.mobile-variants-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: flex-end;\n  z-index: 1060;\n}\n\n.mobile-variants-content {\n  background: white;\n  width: 100%;\n  border-radius: 20px 20px 0 0;\n  max-height: 70vh;\n  overflow-y: auto;\n  animation: slideUp 0.3s ease;\n}\n\n@keyframes slideUp {\n  from {\n    transform: translateY(100%);\n  }\n  to {\n    transform: translateY(0);\n  }\n}\n\n/* Responsive - Hide mobile view on desktop */\n@media (min-width: 769px) {\n  .d-flex.flex-column.vh-100.bg-light {\n    display: none !important;\n  }\n}\n\n/* Custom styles for items that Bootstrap doesn't cover */\n.mobile-item-card {\n  transition: transform 0.2s;\n}\n\n.mobile-item-card:active {\n  transform: scale(0.98);\n}\n\n/* Table View Styles */\n.mobile-table-view-container {\n  padding: 0.5rem 1rem;\n  padding-bottom: 75px;\n  overflow-x: hidden;\n  position: relative;\n}\n\n/* Order Filter Tabs - For All Orders View */\n.mobile-order-filter-tabs {\n  display: inline-flex;\n  width: 100%;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  overflow: hidden;\n  background: white;\n  -webkit-overflow-scrolling: touch;\n}\n\n.mobile-order-filter-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-order-filter-tab {\n  flex: 1;\n  min-width: 90px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: none;\n  border-right: 1px solid #e9ecef;\n  background: white;\n  border-radius: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6c757d;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.mobile-order-filter-tab:last-child {\n  border-right: none;\n}\n.mobile-order-filter-tab.active {\n  background: #2c3e50;\n  border-color: #2c3e50;\n  color: white;\n  position: relative;\n  z-index: 1;\n}\n\n.mobile-order-filter-tab i {\n  font-size: 18px;\n}\n\n.mobile-order-filter-tab span {\n  font-size: 12px;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.mobile-table-types-container {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  overflow-x: scroll;\n  width: auto;\n}\n\n.mobile-table-types-container::-webkit-scrollbar {\n  display: none;\n}\n\n.mobile-table-types-container::-webkit-scrollbar-track {\n  background: #f8f9fa;\n}\n\n.mobile-table-types-container::-webkit-scrollbar-thumb {\n  background: #e9ecef;\n}\n\n.mobile-table-types-container::-webkit-scrollbar-thumb:hover {\n  background: #dee2e6;\n}\n\n.mobile-table-type-filter-btn span {\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.mobile-table-type-filter-btn {\n  white-space: nowrap;\n  border-radius: 5px;\n  flex: 1;\n}\n\n.mobile-table-type-filter-btn i {\n  font-size: 20px;\n  margin-right: 0.5rem;\n}\n\n.mobile-table-layout-container {\n  position: relative;\n}\n\n.mobile-tables-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n  max-width: 450px;\n  margin: 0 auto;\n}\n\n.mobile-table-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.mobile-table-wrapper {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transition: all 0.3s;\n  padding: 15px;\n}\n\n.mobile-table-number-circle {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  font-size: 14px;\n  position: relative;\n  z-index: 2;\n  transition: all 0.3s;\n}\n\n.mobile-table-number-circle.active {\n  background: #ff6b6b;\n  color: white;\n  transform: scale(1.1);\n}\n\n.mobile-table-number-circle.reserved {\n  background: #2c3e50;\n  color: white;\n}\n\n.mobile-table-number-circle.available {\n  background: #ecf0f1;\n  color: #2c3e50;\n}\n\n/* Order Cards */\n.mobile-order-card {\n  border-radius: 0.75rem;\n  padding: 1rem;\n  margin-bottom: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.mobile-order-card.active {\n  background: #2c3e50;\n  border: 2px solid #ff6b6b;\n}\n\n/* Delete Button Inline on Mobile Order Cards */\n.mobile-order-delete-btn-inline {\n  background: transparent;\n  border: none;\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.mobile-order-delete-btn-inline:hover {\n  transform: scale(1.2);\n}\n\n.mobile-order-delete-btn-inline:active {\n  transform: scale(0.9);\n}\n\n.mobile-order-delete-btn-inline .mdi-close-circle {\n  font-size: 24px;\n  color: #dc3545;\n}\n\n/* For active cards, make delete icon white/visible */\n.mobile-order-card.active .mobile-order-delete-btn-inline .mdi-close-circle {\n  color: #ff6b6b;\n}\n\n.mobile-order-card.dine-in {\n  background: #ffeaad;\n}\n\n.mobile-order-card.parcel {\n  background: #e3c8fa;\n}\n\n.mobile-order-card.delivery {\n  background: #c6ffba;\n}\n\n.mobile-order-card.inactive {\n  background: #f8f9fa;\n}\n\n.mobile-order-card-text {\n  color: #2c3e50;\n}\n\n.mobile-order-card.active .mobile-order-card-text {\n  color: white;\n}\n\n.mobile-order-card-subtitle {\n  color: #7f8c8d;\n}\n\n.mobile-order-card.active .mobile-order-card-subtitle {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.mobile-order-card-address {\n  color: #95a5a6;\n}\n\n.mobile-order-card.active .mobile-order-card-address {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.mobile-order-card-price {\n  color: #ff6b6b;\n}\n\n.mobile-order-card.active .mobile-order-card-price {\n  color: white;\n}\n\n.mobile-order-badge-active {\n  background: #ff6b6b;\n  font-size: 11px;\n}\n\n.mobile-order-badge-parcel {\n  background: #27ae60;\n  font-size: 11px;\n}\n\n.mobile-order-badge-delivery {\n  background: #e67e22;\n  font-size: 11px;\n}\n\n/* Empty State */\n.mobile-empty-state {\n  text-align: center;\n  padding: 3rem 0;\n  color: #7f8c8d;\n}\n\n.mobile-empty-state i {\n  font-size: 48px;\n  opacity: 0.3;\n}\n\n/* Legend */\n.mobile-table-legend {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #dee2e6;\n}\n\n.mobile-legend-box {\n  width: 20px;\n  height: 20px;\n  border-radius: 0.25rem;\n}\n\n/* Table chair decorations */\n.mobile-table-chairs {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90px;\n  height: 90px;\n  pointer-events: none;\n}\n\n.mobile-chair {\n  position: absolute;\n  width: 18px;\n  height: 24px;\n  /* background: #bdc3c7;\n border-radius: 6px 6px 3px 3px; */\n}\n\n.mobile-chair.top {\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%) rotate(-10deg);\n}\n\n.mobile-chair.right {\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%) rotate(80deg);\n}\n\n.mobile-chair.bottom {\n  bottom: 10px;\n  left: 50%;\n  transform: translateX(-50%) rotate(170deg);\n}\n\n.mobile-chair.left {\n  left: 10px;\n  top: 50%;\n  transform: translateY(-50%) rotate(260deg);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
